// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1_rnS","header":"MergedInvoice_header__1O7VH"};